module.exports = __webpack_public_path__ + "assets/img/vtuber-ads4.9a94daaf.png";